import React from "react";

/**
 * Simple read-only single address display component for filing summary
 * 
 * Props:
 * - address: Single address object with properties:
 *   - address: Street address
 *   - suiteAddress: Suite/apt (optional)
 *   - city: City
 *   - stateAddress: State
 *   - zipCode: Zip code
 *   - fromDate: Start date (optional)
 *   - toDate: End date (optional)
 * - showDates: Whether to show date range (default: true)
 */
const AddressDisplay = ({ address, showDates = true }) => {
  if (!address) return null;

  const formatDate = (dateString) => {
    if (!dateString) return '';
    try {
      const date = new Date(dateString);
      const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 
                         'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      const month = monthNames[date.getMonth()];
      const year = date.getFullYear();
      return `${month}/${year}`;
    } catch (e) {
      return dateString;
    }
  };

  const getDateRange = () => {
    if (!showDates) return null;
    
    const fromDate = formatDate(address.fromDate);
    const toDate = formatDate(address.toDate);
    
    if (fromDate && toDate) {
      return `${fromDate} - ${toDate}`;
    } else if (fromDate) {
      return `${fromDate} - Present`;
    } else if (toDate) {
      return `Until ${toDate}`;
    }
    return null;
  };

  const getAddressLine = () => {
    const parts = [];
    if (address.address) parts.push(address.address);
    if (address.suiteAddress) parts.push(address.suiteAddress);
    return parts.join(", ");
  };

  const getCityStateZip = () => {
    const parts = [];
    if (address.city) parts.push(address.city);
    if (address.stateAddress) parts.push(address.stateAddress);
    if (address.zipCode) parts.push(address.zipCode);
    return parts.join(", ");
  };

  const dateRange = getDateRange();
  const addressLine = getAddressLine();
  const cityStateZip = getCityStateZip();

  return (
    <div className="address-display-wrapper">
      <div className="address-display-label">Address</div>
      <div className="address-display-item">
        {dateRange && (
          <span className="address-display-date">{dateRange}</span>
        )}
        {addressLine && (
          <span className="address-display-line">{addressLine}</span>
        )}
        {cityStateZip && (
          <span className="address-display-line">{cityStateZip}</span>
        )}
      </div>
    </div>
  );
};

export default AddressDisplay;

